import axios from 'axios'
import { getToken, setToken } from '@/utils/auth'
const service = axios.create({
    //baseURL: 'http://127.0.0.1:8000', // url = base url + request url
    //baseURL: 'http://172.18.20.38:8050/api/',
    baseURL: 'https://sir.diresacajamarca.gob.pe:8050/',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 1000 * 30 // 1000milisegundos * #segundos
})
service.interceptors.request.use(
    config => {
      if (getToken() != null) {
        const token = getToken()
        config.headers['Authorization'] = 'Bearer ' + token
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
  service.interceptors.response.use(
    response => {
      if (response.headers.authorization) {
        setToken(response.headers.authorization)
        response.data.token = response.headers.authorization
      }
      const res = response.data
      return res
    },
    error => {
      if (error.response.status === 401 && getToken() !== null) {
        // to re-login
        console.log('sesion caducada')
      }
      if (error.response.status === 401) {
        // to re-login
        location.reload()
      }
      // se venció el tiempo de csrf
      if (error.response.status === 419) {
        // to re-login csrf timeout
        location.reload()
      }
      // //////////////////////////////////////////////////////////////////////////////////////////////////
      // Mostrar errores no controlados
      // console.log('err ', error.response.status) // for debug
      let mimsgerror = error.message
      let mititle = 'Error inesperado'
      let mimsg = '<ul>'
  
      if (error.response.data && error.response.data.errors) {
        mimsgerror = error.response.data.errors
        if (mimsgerror.message) {
          const _message = mimsgerror.message
          _message.forEach(element => {
            mimsg += '<li>' + element + '</li>'
          })
          mimsg += '</ul>'
        } else {
          mimsg = error.response.data.errors
        }
        // message.message = mimsg
      } else if (error.response.data && error.response.data.error) {
        mimsgerror = error.response.data.error
        if (mimsgerror.message) {
          mimsg = mimsgerror.message
        } else {
          mimsg = error.response.data
        }
      } else {
        mititle = error.response.status
        mimsg = error.message
      }
      if (mimsgerror.title) {
        mititle = mimsgerror.title
      } else {
        mititle = error.response.status
      }
      console.log(mititle)
      console.log(mimsg)
      return Promise.reject(error)
    }
  )
  
  export default service
  